import { getEndCursor } from 'components/Blocks/Pagination/paginationHelpers';
import { DocumentNode } from 'graphql';
import {
    ListedProductConnectionFragmentApi,
    Maybe,
    ProductFilterApi,
    ProductOrderingModeEnumApi,
} from 'graphql/generated';
import { mergeProductEdges } from 'helpers/loadMore/mergeProductEdges';
import { readProductsFromCache } from 'helpers/loadMore/readProductsFromCache';
import { Client } from 'urql';

export const getPreviousProductsFromCache = (
    queryDocument: DocumentNode,
    client: Client,
    urlSlug: string,
    sort: ProductOrderingModeEnumApi | null,
    filter: Maybe<ProductFilterApi>,
    pageSize: number,
    initialPageSize: number,
    currentPage: number,
    currentLoadMore: number,
    readProducts: typeof readProductsFromCache,
): ListedProductConnectionFragmentApi['edges'] | undefined => {
    let cachedPartOfProducts: ListedProductConnectionFragmentApi['edges'] | undefined;
    let iterationsCounter = currentLoadMore;

    if (initialPageSize !== pageSize) {
        const offsetEndCursor = getEndCursor(currentPage);
        const currentCacheSlice = readProductsFromCache(
            queryDocument,
            client,
            urlSlug,
            sort,
            filter,
            offsetEndCursor,
            initialPageSize,
        ).products;

        if (currentCacheSlice) {
            cachedPartOfProducts = currentCacheSlice;
            iterationsCounter -= initialPageSize / pageSize;
        } else {
            return undefined;
        }
    }

    while (iterationsCounter > 0) {
        const offsetEndCursor = getEndCursor(currentPage + currentLoadMore - iterationsCounter);
        const currentCacheSlice = readProducts(
            queryDocument,
            client,
            urlSlug,
            sort,
            filter,
            offsetEndCursor,
            pageSize,
        ).products;

        if (currentCacheSlice) {
            if (cachedPartOfProducts) {
                cachedPartOfProducts = mergeProductEdges(cachedPartOfProducts, currentCacheSlice);
            } else {
                cachedPartOfProducts = currentCacheSlice;
            }
        } else {
            return undefined;
        }

        iterationsCounter--;
    }

    return cachedPartOfProducts;
};
